<template>
  <div ref="viewer"></div>
</template>

<script>
  /* eslint-disable */
  import WebViewer from '@pdftron/pdfjs-express-viewer'
  import axios from 'axios'

  export default {
    name: 'VerEdicao',
    props: {
      path: String
    },
    data() {
      return {
        pathUrl: '',
        searchTerm: '',
        pageNum: 1
      }
    },
    mounted() {
      const me = this
      const params = new URLSearchParams(window.location.search)
      const editionParam = params.get('edition')
      const pageParam = params.get('page')
      const highlightParam = params.get('searchTerm')
      const pathUrl = `${axios.defaults.baseURL}/editions/viewPdf/${editionParam}`

      me.pathUrl = pathUrl
      me.searchTerm = highlightParam
      me.pageNum = parseInt(pageParam)

      WebViewer(
        {
          path: '/static/pdfjsexpress',
          initialDoc: me.pathUrl,
          licenseKey: me.pdfJsExpressKey
        },
        this.$refs.viewer
      ).then((instance) => {
        // now you can access APIs through the WebViewer instance
        const { Core, UI } = instance
        // const { documentViewer, Core, annotationManager, Annotations } =
        const { documentViewer } = instance.Core
        const FitMode = instance.UI.FitMode

        // Core.documentViewer.addEventListener('documentLoaded', () => {
        documentViewer.addEventListener('documentLoaded', () => {
          const searchValue = me.searchTerm

          // set the ui language to pt_BR
          instance.UI.setLanguage('pt_br')

          // instance.UI.searchText(searchValue) // search on page
          instance.UI.searchTextFull(searchValue)

          // ajustando zoom à largura da página
          instance.UI.setFitMode(FitMode.FitWidth)
        })

        Core.documentViewer.addEventListener(
          'activeSearchResultChanged',
          () => {
            Core.documentViewer.setCurrentPage(me.pageNum)
          }
        )

        // adding an event listener for when the page number has changed
        Core.documentViewer.addEventListener(
          'pageNumberUpdated',
          (pageNumber) => {
            // Atualizando page no click do match
            me.pageNum = pageNumber
          }
        )

        // adds a button to the header that on click sets the page to the next page
        UI.setHeaderItems((header) => {
          header.push({
            type: 'actionButton',
            img: 'https://icons.getbootstrap.com/assets/icons/caret-right-fill.svg',
            onClick: () => {
              const currentPage = Core.documentViewer.getCurrentPage()
              const totalPages = Core.documentViewer.getPageCount()
              const atLastPage = currentPage === totalPages

              if (atLastPage) {
                Core.documentViewer.setCurrentPage(1)
              } else {
                Core.documentViewer.setCurrentPage(currentPage + 1)
              }
            }
          })
        })
      })
    },
    computed: {
      pdfJsExpressKey() {
        const urlDiarioAl = 'diario.imprensaoficial.al.gov.br'
        const urlDoeal = 'www.doeal.com.br'
        if (window.location.hostname == urlDiarioAl) {
          return 'ajGjn6fCvON5sKHxSD0m'
        } else if (window.location.hostname == urlDoeal) {
          return 'IKWQx6kMKADlaFk25W1H'
        }
        return process.env.PDFJSEXPRESS_LICENCE_KEY
      }
    }
  }
</script>

<style scoped>
  div {
    width: 100%;
    height: calc(100vh - 122px);
  }
</style>



// WEBPACK FOOTER //
// src/components/VerEdicao.vue